export const UPDATE_SUCURSAL = 'UPDATE_SUCURSAL';